import {defineStore} from 'pinia'
import {ref} from 'vue'

export const useModalStatusStore = defineStore('modalStatusStore', () => {
    const leadModalIsVisible = ref(false)
    const catalogModalIsVisible = ref(false)

    function showLeadModal() {
        leadModalIsVisible.value = true
    }

    function hideLeadModal() {
        leadModalIsVisible.value = false
    }

    function showCatalogModal() {
        catalogModalIsVisible.value = true
    }

    function hideCatalogModal() {
        catalogModalIsVisible.value = false
    }

    return {
        leadModalIsVisible,
        catalogModalIsVisible,
        showLeadModal,
        hideLeadModal,
        showCatalogModal,
        hideCatalogModal
    }
}, {
    persist: true
})
